<template>
  <div>
    <!-- BEGIN panel -->

    <div class="card  border-0 mb-3">
      <div class="card-body">
        <validation-observer ref="form">
          <form v-on:submit="checkForm" method="GET" class="fs-13px">
            <div class="row">
              <legend v-show="!id">Новое задание:</legend>
              <legend v-show="!!id">Редактировать задание:</legend>
              <validation-provider #default="{ errors }" name="title" rules="required|min:3|max:128" vid="title">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Название</label>
                  <div class="col-md-9">
                    <input type="text" v-model="task.title" class="form-control fs-15px" id="floatingInput"
                      placeholder="">
                    <small v-show="!errors[0]">Название (минимум 3 символа ), передающее
                      суть задания.</small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider #default="{ errors }" name="link" rules="required|min:5|max:128" vid="link">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Ссылка</label>
                  <div class="col-md-9">
                    <input type="text" v-model="task.link" class="form-control fs-15px" id="floatingInput" placeholder=""
                      @input="parseLink()">
                    <small v-show="!errors[0]">Ссылка для перехода.</small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider #default="{ errors }" name="type_id" rules="required" vid="type_id">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Тип
                    задания</label>
                  <div class="col-md-9">
                    <select v-model="task.type" class="form-control fs-15px" id="floatingInput" @change="onTypeChange()">
                      <option v-for="type in types" :key="type.id" :value="type.value">{{ type.title }}</option>
                    </select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>



              <div class="row mb-15px">
                <label class="form-label col-form-label col-md-3">Описание: <br>
                  <small>
                    Распишите по
                    пунктам что должен сделать пользователь
                  </small>
                </label>
                <div class="col-md-9">
                  <div v-show="showHints" class="col-md-12">
                    <div class="form-check mt-2 mb-2">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault1"
                        v-model="description.like" @change="parseDesc()">
                      <label class="form-check-label" for="flexCheckDefault1">
                        Поставить лайк
                      </label>
                    </div>
                    <div class="form-check mt-2 mb-2">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2"
                        v-model="description.sub" @change="parseDesc()">
                      <label class="form-check-label" for="flexCheckDefault2">
                        Подписаться
                      </label>
                    </div>
                    <div class="form-check mt-2 mb-2">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault3"
                        v-model="description.comnt" @change="parseDesc()">
                      <label class="form-check-label" for="flexCheckDefault3">
                        Оставить комментарий
                      </label>
                    </div>
                  </div>
                  <validation-provider #default="{ errors }" name="description" rules="required|min:10|max:5120"
                    vid="description">
                    <textarea v-model="task.description" class="form-control" rows="16"
                      id="exampleInputEmail1"></textarea>
                    <small v-show="!errors[0]">Распишите по пунктам, что должен сделать
                      пользователь, не менее 10 символов.</small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <validation-provider #default="{ errors }" name="time_work" rules="required" vid="time_work">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Время на
                    выполнение</label>
                  <div class="col-md-9">
                    <select v-model="task.time_work" class="form-control fs-15px" id="floatingInput">
                      <option value="900">15 мин</option>
                      <option value="1800">30 мин</option>
                      <option value="3600">1 час</option>
                      <option value="21600">6 часов</option>
                      <option value="43200">12 часов</option>
                      <option value="86400">1 сутки</option>
                      <option value="172800">2 суток</option>
                      <option value="259200">3 суток</option>
                    </select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider #default="{ errors }" name="time_check" rules="required" vid="time_check">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Время на
                    проверку</label>
                  <div class="col-md-9">
                    <select v-model="task.time_check" class="form-control fs-15px" id="floatingInput">
                      <option value="900">15 мин</option>
                      <option value="1800">30 мин</option>
                      <option value="3600">1 час</option>
                      <option value="21600">6 часов</option>
                      <option value="43200">12 часов</option>
                      <option value="86400">1 сутки</option>
                      <option value="172800">2 суток</option>
                      <option value="259200">3 суток</option>
                    </select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>
              <validation-provider #default="{ errors }" name="check" rules="required|min:10|max:5120" vid="check">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Информация для
                    подтверждения:<br>
                    <small>
                      Логин на сайте, скриншот с выполнением...
                    </small>
                  </label>
                  <div class="col-md-9">
                    <textarea v-model="task.check" class="form-control" rows="16" id="exampleInputEmail1"></textarea>
                    <small v-show="!errors[0]">Напишите какую информацию пользователь должен
                      оставить в отчёте, чтобы вы
                      проверили
                      правильность выполнения задания. Минимум 10 символов.</small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>

              <!--<div class="row mb-15px">
								<label class="form-label col-form-label col-md-3">Скриншоты</label>
								<div class="col-md-9">
									<select v-model="task.img_cnt" class="form-select" @change="onTypeChange()">
                    <option value="0">Не нужны или загрузить через сторонние сервисы </option>
										<option value="1">1 (+0.3 руб.)</option>
										<option value="2">2 (+0.6 руб.)</option>
										<option value="3">3 (+0.9 руб.)</option>
										<option value="4">4 (+1.2 руб.)</option>
										<option value="5">5 (+1.5 руб.)</option>
									</select>
                  <small> Если Вам не нужны скриншоты в отчете выберите  первый пункт. Если вы хотите чтобы исполнители загружали скриншоты через сторониие сервисы, такие как clip2net.com -  выберите первый пункт. Если вы хотите чтобы пользователи загружали скриншоты на сайт fastsmm.ru выберите нужное количество скриншотов</small>
								</div>
							</div>-->
              <!--
							<div class="row mb-15px">
								<label class="form-label col-form-label col-md-3">Ссылка</label>
								<div class="col-md-9 ps-3">
									<input v-model="task.need_link" class="form-check-input" type="checkbox"
										id="nf_checkbox_css_1">
									<small></small>
								</div>
							</div>-->

              <validation-provider name="countries">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Гео таргетинг <small class="badge bg-primary">NEW</small></label>
                  <div class="col-md-9">
                    <v-select v-if="countries" placeholder="Выбрать страны" v-model="task.countries" :options='countries'
                      :reduce="tag => tag.id" label="name" multiple />
                    <small>Вы можете выбрать одну или несколько стран, исполнители из которых будут выполнять ваши
                      задания</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider #default="{ errors }" name="price" rules="required|decimal" vid="price">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Цена </label>
                  <div class="col-md-9">
                    <input v-model="task.price" type="number" step="0.01" class="form-control fs-15px" />

                    <small v-if="!errors[0]"> Цена должна быть от: {{ min_price }} руб. до 200 руб.</small>
                    <small v-else class="text-danger">Цена должна быть от: {{ min_price }} руб. до 200 руб.</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider name="result_price">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Исполнитель получит</label>
                  <div class="col-md-9">
                    <input disabled v-model="result_price" type="number" class="form-control fs-15px" />
                    <small> 20% от этой суммы идет пользователю, который пригласил исполнителя и 20% идет пользователю
                      который пригласил вас. Комиссия сайта 0%</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider #default="{ errors }" name="count" rules="required|min_value:1|max_value:1000"
                vid="count">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Количество</label>
                  <div class="col-md-9">
                    <input v-model="task.count" type="number" class="form-control fs-15px" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>

              <validation-provider #default="{ errors }" name="time_work" rules="required" vid="itog">
                <div class="row mb-15px">
                  <label class="form-label col-form-label col-md-3">Итог</label>
                  <div class="col-md-9">
                    <input v-model="result" disabled type="number" class="form-control fs-15px" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="d-flex justify-content-center">
              <button @click="$router.push(`/tasks/ALL`);" class="btn btn-default w-100px me-5px">Отмена</button>
              <button :disabled="loading" type="submit" class="btn btn-primary  btn-lg fs-14px w-110px">
                <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> {{ button_label }}</span>
              </button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
    <!-- END panel -->
  </div>
</template>


<script>
import HTTP from "../http";
import {show_error} from "../message";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email, max, min, max_value, min_value} from 'vee-validate/dist/rules';
extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);
extend('max_value', max_value);
extend('min_value', min_value);

extend("decimal", {
  validate: (value, {decimals = '*', separator = '.'} = {}) => {


    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    let min_price = JSON.parse(localStorage.getItem('min_price')) || 0;

    if (value >= min_price && value <= 200.00)
      return {
        valid: regex.test(value),
      };
  },
  message: `Цена  должна быть от ${JSON.parse(localStorage.getItem('min_price')) || 0} до 200.00`
})



export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      errors: null,
      title: null,
      min_price: 0,
      countries: null,
      task: {
        type: 'NULL',
        time_work: 1800,
        time_check: 86400,
        title: null,
        need_link: false,
        description: ``,
        img_cnt: 0,
        check: ``,

      },
      id: 0,
      button_label: 'Добавить',
      description: {
        like: false,
        comnt: false,
        sub: false
      },
      showHints: false,
      photo_price: [0, 0.3, 0.6, 0.9, 1.2, 1.5],
      types: [
        {
          id: 1,
          value: "NULL",
          title: "Не выбрано",
          min_price: 5
        },
        {
          id: 2,
          value: "NETWORKS",
          title: "Соцсети",
          min_price: 0.8
        },
        {
          id: 3,
          value: "SURFING",
          title: "Серфинг",
          min_price: 0.6
        },
        {
          id: 4,
          value: "AVITO",
          title: "Авито",
          min_price: 0.8
        },
        {
          id: 5,
          value: "CLICK",
          title: "Клики",
          min_price: 0.6
        },
        {
          id: 6,
          value: "MESSENGER",
          title: "Мессенджеры",
          min_price: 0.8
        },
        {
          id: 7,
          value: "POSTING",
          title: "Постинг, статьи",
          min_price: 1.5
        },
        {
          id: 8,
          value: "APPLICATION",
          title: "Установка приложений",
          min_price: 2.5
        },
        {
          id: 9,
          value: "REGACT",
          title: "Регистрация с активностью",
          min_price: 3.5
        },
        {
          id: 10,
          value: "REGNOACT",
          title: "Регистрация без активности",
          min_price: 2.5
        },
      ]
    };
  },

  computed: {
    result: function () {
      return (this.task.price * this.task.count).toFixed(2)
    },
    result_price: function () {
      return (this.task.price * 0.6).toFixed(2)
    }

  },

  created() {
    this.id = this.$route.params.id || 0
    console.log('created', this.id)

    if (this.id) {
      this.button_label = 'Сохранить'
      this.fetchData(this.id)
    }

    localStorage.setItem('types', JSON.stringify(this.types))

    this.fetchCountries();
  },

  methods: {
    fetchCountries() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get(`/countries`)
        .then((resp) => {
          this.countries = resp.data;
          console.log('this.countries', this.countries)
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    checkForm: function (e) {
      this.$refs.form.validate().then(success => {
        e.preventDefault();
        if (!success) {
          return;
        }
        this.$insProgress.start();
        this.loading = true;
        if (this.id == 0) { // Create
          HTTP()
            .post("/v2/task", this.task)
            .then((resp) => {
              window.eventBus.$emit('user.update', resp.data.user)
              this.$router.push(`/tasks/ALL`);

            })
            .catch((error) => {
              show_error(this.$notify, this.$refs.form, error.response.data)
            })
            .finally(() => {
              this.loading = false;
              this.$insProgress.finish();
            });
        } else { // Update
          HTTP()
            .put(`/v2/task/${this.id}`, this.task)
            .then((resp) => {
              window.eventBus.$emit('user.update', resp.data.user)
              this.$router.push(`/tasks/ALL`);
            })
            .catch((error) => {
              show_error(this.$notify, this.$refs.form, error.response.data)
            })
            .finally(() => {
              this.loading = false;
              this.$insProgress.finish();
            });
        }
      });
    },

    fetchData(id) {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get(`/v2/task/${id}`)
        .then((resp) => {
          console.log('resp', resp)
          this.task = resp.data
          this.task.countries = this.task.countries.map(x => x.id)
          this.onTypeChange()
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },

    parseLink() {
      console.log('parseLink')
      if (/instagram/.test(this.task.link)) {
        console.log('parseLink NETWORKS')
        this.task.type = 'NETWORKS'
        this.showHints = true
      } else if (/youtu/.test(this.task.link)) {
        this.task.type = 'NETWORKS'
        this.showHints = true
      } else if (/facebook/.test(this.task.link)) {
        this.task.type = 'NETWORKS'
        this.showHints = true
      } else if (/vk.com/.test(this.task.link)) {
        this.task.type = 'NETWORKS'
        this.showHints = true
      } else if (/twitter/.test(this.task.link)) {
        this.task.type = 'NETWORKS'
        this.showHints = true
      } else if (/t.me/.test(this.task.link)) {
        this.task.type = 'NETWORKS'
        this.showHints = true
      }
    },
    parseDesc() {

      this.task.description = ''
      this.task.check = ''

      if (this.description.like) {
        this.task.description += '- Поставить лайк\n'
        this.task.check += '- Скриншот поставленного лайка\n'
      }

      if (this.description.sub) {
        this.task.description += '- Подписаться\n'
        this.task.check += '- Скриншот подписки\n'
      }

      if (this.description.comnt) {
        this.task.description += '- Написать комментарий\n'
        this.task.check += '- Скриншот комментария\n'
      }
    },

    onTypeChange() {
      this.min_price = this.types.find(x => x.value == this.task.type).min_price + this.photo_price[this.task.img_cnt]
      localStorage.setItem('min_price', this.min_price)
    }
  }
}
</script>


<style >
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}
</style>